import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Smartphone, Monitor } from 'lucide-react';
import { useApp } from '../context/AppContext';
import LetsCareersLogo from './LetsCareersLogo';
import './DesktopNav.css';

// „Mobile testen“ ist ein Entwickler-Werkzeug: nur bei npm start. Im Live-Build
// immer Desktop, auch wenn ein Besucher früher 'mobile' gespeichert hat.
const DEV = process.env.NODE_ENV === 'development';

export default function DesktopNav() {
  const navigate = useNavigate();
  const { user, openAuth } = useApp();
  const [isMobile, setIsMobile] = useState(
    () => DEV && localStorage.getItem('layoutMode') === 'mobile'
  );

  useEffect(() => {
    document.body.classList.toggle('layout-mobile', isMobile);
    localStorage.setItem('layoutMode', isMobile ? 'mobile' : 'desktop');
  }, [isMobile]);

  const initials = user
    ? `${(user.first_name?.[0] ?? '').toUpperCase()}${(user.last_name?.[0] ?? '').toUpperCase()}`
    : '';

  return (
    <nav className="d-nav">
      <div className="d-nav__logo">
        <LetsCareersLogo variant="dark" size="lg" />
      </div>

      <div className="d-nav__search" onClick={() => navigate('/search')}>
        <Search size={16} />
        <span>Jobs suchen…</span>
      </div>

      <div className="d-nav__right">
        {DEV && <button
          className={`d-nav__layout-toggle${isMobile ? ' is-active' : ''}`}
          onClick={() => setIsMobile(v => !v)}
          title={isMobile ? 'Zur Desktop-Ansicht' : 'Mobile Ansicht testen'}
        >
          {isMobile ? <Monitor size={15} /> : <Smartphone size={15} />}
          <span>{isMobile ? '← Desktop' : 'Mobile testen'}</span>
        </button>}

        {user ? (
          <div
            className="d-nav__avatar"
            onClick={() => navigate('/profile')}
            title={`${user.first_name ?? ''} ${user.last_name ?? ''}`.trim()}
          >
            <span className="d-nav__initials">{initials}</span>
          </div>
        ) : (
          <button className="d-nav__login" onClick={() => openAuth('login')}>
            Anmelden
          </button>
        )}
      </div>
    </nav>
  );
}
